// Percorsi dell'area aderente, condivisi tra shell e pagine (menu completo come da mockup, STILE-VISUALE.md §4.2).
// Esistono solo "Le mie pratiche" e il dettaglio: gli altri percorsi non hanno ancora una rotta e ricadono
// sul redirect '**' → "Le mie pratiche" finché la pagina non viene sviluppata.
export const HOME_ROUTE           = '/home';
export const PRATICHE_ROUTE       = '/pratiche';
export const POSIZIONE_ROUTE      = '/posizione';
export const CERTIFICAZIONI_ROUTE = '/certificazioni';
export const ACCOUNT_ROUTE        = '/account';
export const NOTIFICHE_ROUTE      = '/notifiche';
// Wizard "Nuova pratica": mockup in mockup/da-validare/nuova-pratica-aderente.html
export const NUOVA_PRATICA_ROUTE  = '/nuova-pratica';
// L'area aderente non ha ancora un login: l'uscita diventerà la logout del servizio di autenticazione.
export const LOGOUT_ROUTE         = '/esci';
